import { RouteComponentProps } from '@reach/router'
import { Box } from 'reoil'
import Navigation from '../components/Navigation'
import useFetchResume from '../hooks/api/useFechResume'
import { responseBoxProp } from '../utils/propsHelpers'
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { MdAdd, MdChevronRight } from 'react-icons/md'
import goto from '../utils/goto'
import { rgba } from 'polished'
import { theme } from '../theme'

interface ResumeResponseEx {
  deliveredJobs: Array<{
    id: string
    name: string
    addtime: string
  }>
}

const MyDeliverredPage: React.FC<RouteComponentProps> = () => {
  const res = useFetchResume<ResumeResponseEx>()
  const resume = res.data?.data

  // 加载中
  if (!resume) return <div></div>

  // 加载完的数据
  const { deliveredJobs } = resume

  // 只投递一个
  const onlyOneDelivered = deliveredJobs.length === 1

  return (
    <Box className='MyDeliveredPage' stretch bg='white'>
      <Navigation title='我的投递' hideAvatar height={59} />

      <Box
        {...responseBoxProp}
        stretch
        p={3}
        borderBox
        css={css`
          h3 {
            margin: 8px 0;
            letter-spacing: 1px;
          }
          p {
            margin: 2px 0;
          }
          .bg-text {
            position: absolute;
            right: 10px;
            bottom: 16px;
            font-weight: bolder;
            font-size: 40px;
            transform: rotate(-30deg);
            opacity: .1;
            z-index: 1;
          }
          .bg-text:last-of-type {
            filter: blur(10px);
          }
        `}>
        {deliveredJobs.map((item, i) => (
          <Box
            key={item.id}
            className='job'
            bg={i&2 ? 'secondary' : 'primary'}
            boxShadow='deepcard'
            color='white'
            p={3}
            borderRadius={2}
            mb={3}
            row
            center
            left
            onClick={()=>goto(`/jobs/${item.id}`)}>
            <Box>
              <h3>{item.name}</h3>
              <p>投递时间: {item.addtime}</p>
            </Box>
            <Box ml='auto'>
              <MdChevronRight size={30} />
            </Box>
            <span className='bg-text'>已投递</span>
            <span className='bg-text'>已投递</span>
          </Box>
        ))}
        {onlyOneDelivered && <Box
          className='job'
          bg={rgba(theme.colors.secondary, .03)}
          border='secondary'
          color='secondary'
          p={3}
          borderRadius={2}
          mb={3}
          row
          center
          left
          onClick={()=>goto(`/jobs`)}>
          <Box>
            <h3>我要投递</h3>
            <p style={{opacity: .6}}>最多投递2份, 您还可以投递1份</p>
          </Box>
          <Box ml='auto'>
            <MdAdd size={30} />
          </Box>
        </Box>}
      </Box>
    </Box>
  )
}

export default MyDeliverredPage
